import { ProcessStep } from './../../models/process-step.model';
import talentApi from './talent-api-config';
import { AxiosResponse } from "axios";


class ProcessStepApi{

    async fetchSelectedCandidatesProcessSteps(uuids: string[]): Promise<AxiosResponse<any>>{
        const data = {
            uuids: uuids
        };
        return talentApi.post<any>(`/talent/candidate-process-step/list-selecteds/`, data);
    }

    async fetchProcessSteps(companyId: string): Promise<AxiosResponse<ProcessStep[]>>{
        return talentApi.get<ProcessStep[]>(`/talent/process-step/${companyId}/`);
    }

    async fetchCandidateProcessStep(candidateId: string): Promise<AxiosResponse<ProcessStep>>{
        return talentApi.get<ProcessStep>(`/talent/candidate-process-step/${candidateId}/`);
    }

    async updateCandidateProcessStep(candidateId: string, processStepId: string, recruiterId: string): Promise<AxiosResponse<ProcessStep>>{
        const data = {
            process_step_uuid: processStepId,
            recruiter_uuid: recruiterId
        };
        return talentApi.put<ProcessStep>(`/talent/candidate-process-step/${candidateId}/`, data);
    }

    async createCandidateProcessStep(candidateId: string, processStepId: string, recruiterId: string): Promise<AxiosResponse<ProcessStep>>{
        const data = {
            process_step_uuid: processStepId,
            recruiter_uuid: recruiterId
        };
        return talentApi.post<ProcessStep>(`/talent/candidate-process-step/${candidateId}/`, data);
    }

}


export const processStepApi = new ProcessStepApi();